import DeleteAccountInstruction from './DeleteAccountInstruction';

export default DeleteAccountInstruction;
